import { riskManagementResourceAdapter } from './RiskManagement.resource';
export function pingPongResource(data) {
    var _data$account, _data$account2, _data$account3, _data$pair, _data$pair2, _data$pair3, _data$account4, _data$account5, _data$account6, _data$account7, _data$account8, _data$account9, _data$pair4, _data$pair5, _data$pair6, _data$pair7, _data$pair8;
    var accountBroker = {
        id: (_data$account = data.account) === null || _data$account === void 0 ? void 0 : _data$account.broker.id,
        name: (_data$account2 = data.account) === null || _data$account2 === void 0 ? void 0 : _data$account2.broker.name,
        separator: (_data$account3 = data.account) === null || _data$account3 === void 0 ? void 0 : _data$account3.broker.name,
        hasUniqueTradeId: data.account.broker.hasUniqueTradeId
    };
    var pairBroker = {
        id: (_data$pair = data.pair) === null || _data$pair === void 0 ? void 0 : _data$pair.broker.id,
        name: (_data$pair2 = data.pair) === null || _data$pair2 === void 0 ? void 0 : _data$pair2.broker.name,
        separator: (_data$pair3 = data.pair) === null || _data$pair3 === void 0 ? void 0 : _data$pair3.broker.separator,
        hasUniqueTradeId: data.account.broker.hasUniqueTradeId
    };
    var account = {
        id: (_data$account4 = data.account) === null || _data$account4 === void 0 ? void 0 : _data$account4.id,
        name: (_data$account5 = data.account) === null || _data$account5 === void 0 ? void 0 : _data$account5.name,
        key: (_data$account6 = data.account) === null || _data$account6 === void 0 ? void 0 : _data$account6.key,
        secret: (_data$account7 = data.account) === null || _data$account7 === void 0 ? void 0 : _data$account7.secret,
        passphrase: (_data$account8 = data.account) === null || _data$account8 === void 0 ? void 0 : _data$account8.passphrase,
        broker: accountBroker,
        pair: (_data$account9 = data.account) === null || _data$account9 === void 0 ? void 0 : _data$account9.pair,
        client: data.account.client,
        main: data.account.main,
        type: data.account.type,
        mainAccount: data.account.mainAccount
    };
    var pair = {
        id: (_data$pair4 = data.pair) === null || _data$pair4 === void 0 ? void 0 : _data$pair4.id,
        name: (_data$pair5 = data.pair) === null || _data$pair5 === void 0 ? void 0 : _data$pair5.name,
        baseCurrency: (_data$pair6 = data.pair) === null || _data$pair6 === void 0 ? void 0 : _data$pair6.baseCurrency,
        quoteCurrency: (_data$pair7 = data.pair) === null || _data$pair7 === void 0 ? void 0 : _data$pair7.quoteCurrency,
        maxSum: (_data$pair8 = data.pair) === null || _data$pair8 === void 0 ? void 0 : _data$pair8.maxSum,
        broker: pairBroker,
        restartMaxTimeValue: data.pair.restartMaxTimeValue,
        minQuantity: data.pair.minQuantity
    };
    var riskManagement = riskManagementResourceAdapter(data.riskManagement);
    return {
        id: data === null || data === void 0 ? void 0 : data.id,
        account: account,
        pair: pair,
        active: data === null || data === void 0 ? void 0 : data.active,
        state: data.state,
        createdAt: data === null || data === void 0 ? void 0 : data.createdAt,
        buyPercentage: data === null || data === void 0 ? void 0 : data.buyPercentage,
        sellPercentage: data === null || data === void 0 ? void 0 : data.sellPercentage,
        duration: data === null || data === void 0 ? void 0 : data.duration,
        intervalType: data === null || data === void 0 ? void 0 : data.intervalType,
        interval: data === null || data === void 0 ? void 0 : data.interval,
        sumType: data === null || data === void 0 ? void 0 : data.sumType,
        sumBid: data === null || data === void 0 ? void 0 : data.sumBid,
        sumAsc: data === null || data === void 0 ? void 0 : data.sumAsc,
        statuses: data.statuses,
        changeInPercentage: data.changeInPercentage,
        hedging: data.hedging,
        riskManagement: riskManagement
    };
}
